import React, { useEffect, useState, useRef, createContext, useCallback, useContext, useMemo } from 'react';
import { useBreakpoints } from 'react-hook-breakpoints';
import NumberFormat from 'react-number-format';
import { InputGroupAddon, Button, Card, CardBody, TabPane, Nav, TabContent, NavItem, NavLink, Modal, ModalBody, Row, Col, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBackspace, faUndo } from '@fortawesome/free-solid-svg-icons';
import translate from 'redux-polyglot/translate';
import { connect, useDispatch, useSelector } from 'react-redux';
import PlayStore from '../store/Play';

// const _metrics = [
//     { div: 1, unit: '' },
//     { div: 1_000, unit: 'K' },
//     { div: 1_000_000, unit: 'M' },
//     // { div: 1_000_000_000, unit: 'B' },
// ]
let _simpleAmounts = [
    100, 200, 500,
    1_000, 2_000, 5_000,
    10_000, 20_000, 50_000,
    100_000, 500_000, 1_000_000,
];
function formatWithMetric(value) {
    for (var i = 0; value >= 1000; i++) {
        value /= 1000;
    }
    return value + ['', 'K', 'M', 'B'][i];
}
// for (let { div, unit } of _metrics) {
//     for (let m = 1; m < 1_000; m *= 10) {
//         _simpleAmounts = [
//             ..._simpleAmounts,
//             { amount: 1 * m * div, display: `${1 * m}${unit}` },
//             { amount: 2 * m * div, display: `${2 * m}${unit}` },
//             { amount: 5 * m * div, display: `${5 * m}${unit}` },
//         ];
//     }
// }
const NUMPAD_MAX_AMOUNT = 1_000_000;
_simpleAmounts = _simpleAmounts.filter(a => a <= NUMPAD_MAX_AMOUNT).sort((a, b) => b - a);

export const NumpadContext = createContext({
    value: '',
    isOpen: false,
    inputRef: null,
})

const NumpadProvider = connect(
    state => ({ play: state.play }),
    { ...PlayStore.actionCreators }
)(function ({ play, allowEmpty = true, disabled = false, nextRef, children, ...props }) {

    const [value, setValue] = useState('')
    const [options, setOptions] = useState({})
    const [mode, setMode] = useState('manual')
    const open = useCallback((_options) => {
        console.debug('open()', _options.target, _options.inputRef)
        if (!document.contains(_options.target) || _options.target.disabled)
            return;
        setIsOpen(true);
        setOptions(_options)
    }, [])

    const updateOptions = useCallback((_options) => {
        setOptions(_options)
    }, [])
    const [isOpen, setIsOpen] = useState(false);

    const toggleModal = useCallback((isOpen) => {
        if (typeof isOpen === 'undefined') {
            setIsOpen(_isOpen => {
                console.debug(`toggleModal()`)
                if (_isOpen) {
                    options.onLeave?.()
                    setOptions({})
                }
                return !_isOpen
            });
        }
        else {
            console.debug(`toggleModal(${isOpen})`)
            if (!isOpen) {
                options.onLeave?.()
                setOptions({})
            }
            setIsOpen(isOpen);
        }
    }, [options])

    useEffect(() => {
        if (play.currency) {
            props.requestNumpad(play.currency)
        }
    }, [play.currency])

    return (
        <>
            <NumpadContext.Provider value={{
                value, setValue,
                isOpen,
                toggleModal,
                open,
                options, updateOptions,
                mode, setMode
            }}>
                {children}
                <NumpadModal></NumpadModal>
            </NumpadContext.Provider>
        </>
    )
})
export default NumpadProvider

export const NumpadModal = translate()(function ({ allowEmpty = true, disabled = false, delay = 500, throttle: repeatInterval = 100, p: { tu }, ...props }) {

    const { value, options: { target, min, max, step, maxLength, autoSelect, autoNext, inputRef, numberFormatRef, nextRef, simple, customEnter, customHeader, ...options },
        isOpen, toggleModal, mode, setMode } = useContext(NumpadContext);

    const allowDecimal = useMemo(() => !Number.isInteger(step), [step]);
    const nummm = useSelector(state=>state.play);
    console.log(nummm);
    const numpadSettings = useSelector(state => state.play.numpad);

    const simpleAmounts = useMemo(() => {
        let amts = numpadSettings
            // .filter(({ amount: amt }) => min <= amt && amt <= max && (!maxLength || `${amt}`.length <= maxLength))
            .map(({ amount }) => amount).sort((a, b) => b - a)
        let rows = [];
        for (let i = 0; amts.length; i++) {
            let cells = []
            for (let j = 0; j < 3 && amts.length; j++) {
                cells.push(amts.pop())
            }
            rows.unshift(cells);
        }
        return rows;
    }, [min, max, maxLength])

    useEffect(() => {
        if (target) {
            console.trace('effect[target]', target)
            if (!document.contains(target) || target.disabled) {
                toggleModal(false)
                return;
            }
            target.classList.add('numpad-highlight')
            // target.style.position = 'relative';
            // target.style.zIndex = 1050;

            return () => {
                target.classList.remove('numpad-highlight')
                // target.style.position = '';
                // target.style.zIndex = ''
                // if(target != oldTarget.current)
                // console.debug('useEffect cleanup', target, oldTarget.current)
                //     options.onLeave?.()
            }
        }
        return () => {
            // console.debug('useEffect cleanup', target, oldTarget.current)
        }
    }, [target])

    // Repeating
    const intervalRef = useRef()
    const startRef = useRef()

    const startRepeating = (fun) => {
        stopRepeating()
        startRef.current = setTimeout(() => {
            let t = Date.now();
            intervalRef.current = setInterval(() => {
                var d = Date.now() - t;
                console.log(d);
                if (d > repeatInterval * 1.5) {
                    stopRepeating();
                    return;
                }
                fun();
                t = Date.now();
            }, repeatInterval)
        }, delay)
    }

    const stopRepeating = () => {
        if (startRef.current) {
            clearTimeout(startRef.current)
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
                intervalRef.current = null
            }
        }
    }

    useEffect(() => {
        const _blur = () => {
            // console.log('window.blur()')
            stopRepeating()
        };
        window.addEventListener('blur', _blur)
        // window.addEventListener('focus', (event) => {
        //     console.trace(event, document.activeElement)
        // }, {
        //     capture: true
        // })
        return () => {
            clearTimeout(startRef.current)
            clearInterval(intervalRef.current)
            window.removeEventListener('blur', _blur);
        }
    }, [])


    const handleModalOpened = useCallback(() => {
        if (!document.contains(target) || target.disabled) {
            toggleModal(false)
            return;
        }
    }, [target])

    const handleModalClosed = useCallback(() => {
        stopRepeating()
    }, [])

    const { currentBreakpoint, breakpoints } = useBreakpoints()

    const btnStyle = {
        width: 50,
        fontSize: '1.2rem',
        paddingTop: '0.1rem',
        paddingBottom: '0.1rem',
    }

    useEffect(() => {
        setMode(simple ? 'simple' : 'manual');
    }, [simple])

    const handleButtonPointerDown = (event) => {
        if (intervalRef.current) return

        const value = event.currentTarget.value
        options.onButtonDown?.(value);

        if (value === 'Backspace') {
            options.onBackspace?.();
            startRepeating(() => options.onBackspace?.());
        }
        else if (value === 'Undo') {
            options.onUndo?.();
            startRepeating(() => options.onUndo?.());
        }
        else if (value === 'Double') {
            options.onDouble?.();
            startRepeating(() => options.onDouble?.());
        }
        else if (value === 'Clear') {
            options.onClear?.();
        }
        else if (value === 'Enter') {
            options.onEnter?.();
        }
        else if (mode === 'manual') {
            options.onKey?.(value);
            startRepeating(() => options.onKey?.(value));
        }
        else if (mode === 'simple') {
            if (value === '0') {
                options.onKey?.(value)
                startRepeating(() => options.onKey?.(value));
            }
            else {
                options.onAmount?.(+value);
                startRepeating(() => options.onAmount?.(+value));
            }
        }
        event.preventDefault();
        event.stopPropagation();
    }
    const handleButtonBlur = (event) => {
        stopRepeating()
    }
    const handleButtonPointerLeave = (event) => {

        stopRepeating()

        event.preventDefault();
        event.stopPropagation();
    }
    const handleButtonPointerUp = (event) => {

        stopRepeating()

        event.currentTarget.blur();

        event.preventDefault();
        event.stopPropagation();
    }
    const buttonEventHandlers = {
        onPointerDown: handleButtonPointerDown,
        onPointerUp: handleButtonPointerUp,
        onPointerLeave: handleButtonPointerLeave,
        onBlur: handleButtonBlur
    }

    const CustomEnter = customEnter

    return <>
        <Modal backdropClassName="bg-transparent" size="lg" isOpen={isOpen} toggle={() => toggleModal()} returnFocusAfterClose={false}
            onOpened={handleModalOpened} onClosed={handleModalClosed}
            modalClassName="d-flex flex-column justify-content-end mw-100 numpad" className="w-100 my-0 mx-auto" style={{ maxWidth: "calc(100vh / 16 * 9)" }}>
            <ModalBody>
                {customHeader}
                {simple &&
                    <Nav tabs justified className="mb-3">
                        <NavItem>
                            <NavLink
                                className={mode === 'simple' ? 'active' : ''}
                                onClick={() => setMode('simple')}>
                                {tu('simple')}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={mode === 'manual' ? 'active' : ''}
                                onClick={() => setMode('manual')}>
                                {tu('manual')}
                            </NavLink>
                        </NavItem>
                    </Nav>
                }
                {/* {maxLength != 1 &&
                    <NumberFormat displayType="text" className="form-control number-input text-right mb-3"
                        thousandSeparator={true} allowNegative={false} allowLeadingZeros
                        readOnly
                        value={value} />
                } */}
                {/* <NumberFormat displayType="text" className="form-control text-right px-0"
                    thousandSeparator={true} allowNegative={false} allowLeadingZeros={false}
                    disabled={true} decimalScale={0}
                    value={value ?? ''} /> */}
                <TabContent activeTab={mode} className="col">
                    {simpleAmounts &&
                        <TabPane tabId="simple">
                            <Row>
                                <Button size="lg" value="Clear" outline color="white" className="col-4 font-weight-bold" {...buttonEventHandlers}>C</Button>
                                <Button size="lg" value="Undo" outline color="white" className="offset-4 col-4" {...buttonEventHandlers}><FontAwesomeIcon icon={faUndo} /></Button>
                            </Row>
                            {simpleAmounts.map((amounts, i) => <Row key={`simple-row-${i}`}>
                                {amounts.map((amount, j) => (amount && <Button key={`simple-btn-${j}`} size="lg" value={`${amount}`} outline color="white" className="col"
                                    {...buttonEventHandlers}
                                    disabled={step > amount || amount > max || (maxLength && `${amount}`.length > maxLength)}>{formatWithMetric(amount)}</Button>
                                    || <Col></Col>)
                                )}
                            </Row>)}
                            <Row>
                                {/* <Button size="lg" value="Clear" outline color="white" className="col font-weight-bold" {...buttonEventHandlers}>C</Button> */}
                                <Button size="lg" value="Double" outline color="white" className="offset-4 col-4" {...buttonEventHandlers}>x2</Button>
                                {CustomEnter ?
                                    <CustomEnter {...buttonEventHandlers}></CustomEnter>
                                    :
                                    <Button size="lg" value="Enter" color="gold" className="col-4" {...buttonEventHandlers}><FontAwesomeIcon icon={faArrowRight} /></Button>
                                }
                            </Row>
                        </TabPane>
                    }
                    <TabPane tabId="manual">
                        <Row>
                            <Button size="lg" value="Clear" outline color="white" className="col-4 font-weight-bold" {...buttonEventHandlers}>C</Button>
                            <Button size="lg" value="Backspace" outline color="white" className="offset-4 col-4" {...buttonEventHandlers}><FontAwesomeIcon icon={faBackspace} /></Button>
                        </Row>
                        <Row>
                            <Button size="lg" value="1" outline color="white" className="col" {...buttonEventHandlers}>1</Button>
                            <Button size="lg" value="2" outline color="white" className="col" {...buttonEventHandlers}>2</Button>
                            <Button size="lg" value="3" outline color="white" className="col" {...buttonEventHandlers}>3</Button>
                        </Row>
                        <Row>
                            <Button size="lg" value="4" outline color="white" className="col" {...buttonEventHandlers}>4</Button>
                            <Button size="lg" value="5" outline color="white" className="col" {...buttonEventHandlers}>5</Button>
                            <Button size="lg" value="6" outline color="white" className="col" {...buttonEventHandlers}>6</Button>
                        </Row>
                        <Row>
                            <Button size="lg" value="7" outline color="white" className="col" {...buttonEventHandlers}>7</Button>
                            <Button size="lg" value="8" outline color="white" className="col" {...buttonEventHandlers}>8</Button>
                            <Button size="lg" value="9" outline color="white" className="col" {...buttonEventHandlers}>9</Button>
                        </Row>
                        <Row>
                            <Button size="lg" value="." outline color="white" className="col" {...buttonEventHandlers} disabled={!allowDecimal || `${value}`.includes('.')}>.</Button>
                            <Button size="lg" value="0" outline color="white" className="col" {...buttonEventHandlers}>0</Button>
                            <Button size="lg" value="Enter" color="gold" className="col" {...buttonEventHandlers}><FontAwesomeIcon icon={faArrowRight} /></Button>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
        </Modal>
        {/* {
                breakpoints[currentBreakpoint] == breakpoints.mobile
                &&
                <InputGroupAddon addonType="prepend">
                    <Button type="button" className="bg-gradient-danger" style={btnStyle} disabled={disabled}
                        onPointerDown={subtract} onPointerUp={subtract} tabIndex="-1">-</Button>
                </InputGroupAddon>
            }
            {children}
            <InputGroupAddon addonType="append">
                {
                    breakpoints[currentBreakpoint] != breakpoints.mobile
                    && <Button type="button" className="bg-gradient-danger" style={btnStyle} disabled={disabled}
                        onPointerDown={subtract} onPointerUp={subtract} tabIndex="-1">-</Button>
                }
                <Button type="button" className="bg-gradient-success" style={btnStyle} disabled={disabled}
                    onPointerDown={add} onPointerUp={add} tabIndex="-1">+</Button>
            </InputGroupAddon> */}
    </>
})